export const flightRoutes = {
    path: "flight",
    name: "flightFormview",
    alias: "/flight",
    meta: { requiresAuth: true, title: 'Dreasyfly - Flight Booking' },
    component: () => import('../../flight/views/flightForm.vue'),
    children: [
        {
            path: 'details',
            name: 'filghtDetails',
            alias: '/details',
            component: () => import('../../flight/views/flightDetails.vue')
        },
        {
            path: 'pre_booking_page',
            name: 'filghtBookingDetails',
            alias: '/pre_booking_page',
            component: () => import('../../flight/views/filghtBookingDetails.vue')
        },
        {
            path: 'refund_report',
            name: 'refund_report',
            alias: '/refund_report',
            component: () => import('../../flight/views/flightRefundReport.vue')
        },
        {
            path: 'refund_receipt',
            name: 'refund_receipt',
            alias: '/refund_receipt',
            component: () => import('../../flight/views/refundReceipt.vue')
        },
        {
            path: 'bookingreport',
            name: 'flightBookingreport',
            alias: '/bookingreport',
            component: () => import('../../flight/views/filghtReport.vue')
        },
        {
            path: "view-flight-ticket/:transactionId?",
            name: "FlightTicketView",
            alias: "/view-flight-ticket",
            component: () => import('../../flight/views/TicketView.vue'),
        },
        
        {
            path: 'review_page',
            name: 'filghtBookingReview',
            alias: '/review_page',
            component: () => import('../../flight/views/filghtBookingReview.vue')
        },
        {
            path: 'process_ticket/:app_reference?',
            name: 'filghtProcessTicket',
            alias: '/pre_booking_page',
            component: () => import('../../flight/views/filghtProcessTicket.vue')
        },
        {
            path: 'cancel_ticket/:app_reference?',
            name: 'filghtCancelTicket',
            alias: '/pre_booking_page',
            component: () => import('../../flight/views/CancellationView.vue')
        }

        // {
        //     path: "cancel_flight_booking_view/:transactionId?",
        //     name: "cancelFlightBookingView",
        //     alias: "/cancel_flight_booking_view",
        //     component: () => import('../../flight/views/CancellationView.vue'),
        // },
    ]
}